import type { Domaine } from '@/models/interfaces/Domaine'
import { apiClient } from '@/plugins/axios/api'

export class DomaineService {
  static async getAll(): Promise<Domaine[]> {
    try {
      const response = await apiClient.get('/api/domaines')
      return response.data['hydra:member'] || []
    } catch {
      console.debug('Domaine endpoint not available yet, returning empty array.')
      return []
    }
  }
}
